import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [RouterLink],
  template: ` <main
    id="main-content"
    tabindex="-1"
    class="bg-white text-slate-900 px-6 py-20 min-h-[60vh] text-center"
  >
    <p class="font-bold text-blue-700 mb-3">404 · Page not found</p>
    <h1 class="text-4xl font-bold mb-4">This page couldn't be found</h1>
    <p class="mb-8">
      The link may have changed, or the address may contain a typo.
    </p>
    <div class="flex flex-wrap justify-center gap-4">
      <a routerLink="/" class="btn btn-primary">Go home</a>
      <a routerLink="/search" class="btn btn-outline">Search content</a>
    </div>
  </main>`,
})
export class NotFoundComponent {}
